import UsuariosCrudTemplate from "../../components/templates/usuariosCrud/UsuariosCrudTemplate"

const UsuariosCrud = () => {
    return <UsuariosCrudTemplate/>;
};

export default UsuariosCrud;